import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import MoreIcon from '@mui/icons-material/MoreVert';
import SaveIcon from '@mui/icons-material/Save';
import ViewInArIcon from '@mui/icons-material/ViewInAr';

import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { Avatar, AvatarGroup, ButtonBase, Menu, MenuItem, Tooltip } from '@mui/material';
import { useProfile } from '../common/useProfile';
import Service from '../../util/Service';
import { green, yellow } from '@mui/material/colors';
import { Feedback, Home, MonitorHeart } from '@mui/icons-material';
import MembrosAvatarGroup from './MembrosAvatarGroup';

const drawerWidth = 240;

const Main = styled('main', { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme }) => ({
    flexGrow: 1,
    marginTop: theme.spacing(3),
    // padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: `-${drawerWidth}px`,
    variants: [
      {
        props: ({ open }) => open,
        style: {
          transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          marginLeft: 0,
        },
      },
    ],
  }),
);

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme }) => ({
  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  variants: [
    {
      props: ({ open }) => open,
      style: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: `${drawerWidth}px`,
        transition: theme.transitions.create(['margin', 'width'], {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.enteringScreen,
        }),
      },
    },
  ],
}));

const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

export function temAcessoAoProjeto(projeto, prof, papeis, rules ){
  if( !prof.profile) return false;
  for(const r of rules){
    if (prof.temAcesso(r)) {
        return true;
    }
  }
  if( projeto.membros && papeis){
      const papelPrj = projeto.membros.find(m => m.id === prof.profile.id);
      if( papelPrj){
          const papel = papeis.find( p => p.confs.nome === papelPrj.papel)
          if( papel){
            for(const r of rules){
              const has = papel.confs.regras.find( regra => regra === r);
              if( has) return true;
            }
          }
      }
  }
  return false;
}
export default function ProjetoRoot() {
  const navigate = useNavigate();
  const location = useLocation();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);
  const [title, setTitle] = React.useState({
    variant: 'h6',
    txt: 'Projetos',
  });
  const [actionMenu, setActionMenu] = React.useState([])
  const [saveMenu, setSaveMenu] = React.useState();
  const [membros, setMembros] = React.useState();
  // const [background, setBackground]= React.useState();
  const [stylePage, setStylePage]= React.useState(
    {minHeight:'90vh'}
  );

  const [anchorEl, setAnchorEl] = React.useState(null);

  const prof = useProfile();

  React.useEffect(() => {
    if (prof.profile) {
      const accessToken = localStorage.getItem("accessToken");
      Service.GET("/api/user/checkAccessToken/" + accessToken).then(r => {
        if (!r.valid) {
          navigate("/login");
          return;
        }

      })
    } else if (!prof.isOk) {
      console.log('Não esta OK!!!');
    }
  }, [prof.profile, prof.isOk]);



  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleAction = (ac) => {
    if (typeof ac === 'string') {
      setStylePage({minHeight:'90vh'});
      navigate(ac);
    } else if (typeof ac === 'function') {
      ac();
    }
    handleClose();
  }

  const update = (e) => {
    setSaveMenu();
    setMembros();
    setActionMenu();
    if( !e)return;

    if (e.title) {
      setTitle(e.title);
    }
    if (e.membros) {
      setMembros(e.membros);
    }
    if (e.actions) {
      setActionMenu(e.actions);
    }
    if (e.save) {
      setSaveMenu(e.save);
    }
    if( e.fundo){
      if( e.fundo.cor){
        setStylePage({
            background: e.fundo.cor,
            minHeight:'90vh'
          })
      }else if( e.fundo.anexo){
        setStylePage({
            // backgroundImage: `url(/api/getAnexoById/${e.fundo.anexo})`,
            backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), url(/api/getAnexoById/${e.fundo.anexo})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            minHeight:'90vh'
          })
      }
    }
    handleClose();
  }

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  function MontaSaveMenu() {
    return (

      <Tooltip title={saveMenu.tip}>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={() => handleAction(saveMenu.ac)}
          color="inherit"
        >
          <SaveIcon />
        </IconButton>
      </Tooltip>

    )
  }

  function MontaActionMenu() {
    return (
      <div>
        <IconButton
          size="large"
          aria-label="account of current user"
          aria-controls="menu-appbar"
          aria-haspopup="true"
          onClick={handleMenu}
          color="inherit"
        >
          <MoreIcon />
        </IconButton>
        <Menu

          id="menu-appbar"
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          keepMounted
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {actionMenu && actionMenu.map((row, index) => {
            if (row.nome === 'Divider') {
              return (
                <Divider key={index} />
              )
            }
            if (typeof row.ac === 'object') {
              return (
                <div key={index} style={{ padding: 5 }}>
                  {row.ac}
                </div>
              );
            }
            return (
              <MenuItem key={index} onClick={() => handleAction(row.ac)}>{row.nome}</MenuItem>
            )
          }
          )}
        </Menu>
      </div>
    )
  }


  if (prof.isOk && !prof.profile) {
    console.log("????????")
    setTimeout(() => {
      localStorage.setItem("page", location.pathname);
      navigate('/login');

    }, 3000);

    return (
      <div style={{ width: '100%', height: '100vh', alignItems: 'center', textAlign: 'center', alignContent: 'center' }}>
        <p>Não logado....identifique-se</p>
      </div>
    );
  }
  if (!prof.isOk && !prof.profile) {
    setTimeout(() => {
      const call = Service.GET("/api/security/profile");
      if (call) {
        call
        .then(ret => {})
        .catch((e) => {
          localStorage.setItem("page", location.pathname);
          navigate('/login');
        });
      }else{
        console.log( call );
        localStorage.setItem("page", location.pathname);
        navigate('/login');
      }
    }, 3000);

    return (
      <div style={{ width: '100%', height: '100vh', alignItems: 'center', textAlign: 'center', alignContent: 'center' }}>
        <p>Não logado....<a href='/login'>identifique-se</a></p>
      </div>
    );
  }

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar position="fixed" open={open}>
        <Toolbar>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            onClick={handleDrawerOpen}
            edge="start"
            sx={[
              {
                mr: 2,
              },
              open && { display: 'none' },
            ]}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant={title.variant} noWrap component="div">
            {title.txt}
          </Typography>

          <Box component="div" sx={{ flexGrow: 1 }}>

          </Box>
          {/* {membros && <MembrosAvatarGroup membros={membros} /> } */}
          {(membros && membros) &&
            <div>
              {membros}
            </div>}
          {saveMenu && MontaSaveMenu()}
          {(actionMenu && actionMenu.length > 0) && MontaActionMenu()}


        </Toolbar>
      </AppBar>
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
          },
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <DrawerHeader>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
          </IconButton>
        </DrawerHeader>
        <Divider />
        <List>
          <ListItem disablePadding>
            <ListItemButton href="/">
              <ListItemIcon >
                <Home />
              </ListItemIcon>
              <ListItemText primary={"Tela inicial"} />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton href="/project">
              <ListItemIcon >
                <ViewInArIcon />
              </ListItemIcon>
              <ListItemText primary={"Projetos"} />
            </ListItemButton>
          </ListItem>
        </List>
        <Divider />
        <List>

          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <Feedback />
              </ListItemIcon>
              <ListItemText primary="Relatório" />
            </ListItemButton>
          </ListItem>
          <ListItem disablePadding>
            <ListItemButton>
              <ListItemIcon>
                <MonitorHeart />
              </ListItemIcon>
              <ListItemText primary="Monitorar" />
            </ListItemButton>
          </ListItem>
        </List>
      </Drawer>
      <Main open={open} sx={stylePage}>
        <DrawerHeader />
        <Outlet context={{ update }} />
      </Main>
    </Box>
  );
}
